
import { defineComponent } from 'vue';
import { AudioPlayer } from '../player';
import { QueueManager } from './play-queue';
import { Settings } from '../common/settings';
import QueueTrackListing from './QueueTrackListing.vue';
import QueuePicker from './QueuePicker.vue';
import { LibraryManager } from '../library';

export default defineComponent({
    components: { QueuePicker, QueueTrackListing },
    props: {
        player: {
            type: AudioPlayer,
            required: true,
        },
        libraryManager: {
            type: LibraryManager,
            required: true,
        },
        queueManager: {
            type: QueueManager,
            required: true,
        },
        settings: {
            type: Settings,
            required: true,
        },
    },
});
